import { useEffect, useRef } from 'react';

const useScrollToDivOnLoad = () => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
      setTimeout(() => {
        ref.current.scrollIntoView({ behavior: 'smooth' });
      }, 1000);
    }
  }, []);

  return ref;
};

export default useScrollToDivOnLoad;
